import { __awaiter } from "tslib";
import Vue from "vue";
import moment from "moment";
import { FonasaValidationService } from "@/servicesTs/models/general/fonasaValidation";
import { PatientService } from "@/services/models/patient";
import { FonasaValidationHistoryService } from "@/servicesTs/models/general/fonasaValidationHistory";
export default Vue.extend({
    props: {
        patient_data: {
            required: true,
            type: Object,
        },
        fonasa_data: {
            required: true,
            type: Object,
        },
    },
    data() {
        return {
            differences: {},
            fieldsSelected: {},
        };
    },
    computed: {
    // patientState() {
    //   return this.patient_data.state == "active" ? "Activo" : "Pasivo";
    // },
    // fonasaDeceased() {
    //   return this.fonasa_data.deceased_date ? "Pasivo" : "Activo";
    // },
    },
    mounted() {
        this.compareAllFields();
    },
    methods: {
        toggleField(key, value) {
            if (value === null) {
                this.$delete(this.fieldsSelected, key);
            }
            else {
                if (key == "deceased_date") {
                    console.log(key, value);
                    this.$set(this.fieldsSelected, "state", value == "Pasivo" ? "pasive" : "active");
                }
                else {
                    this.$set(this.fieldsSelected, key, value);
                }
            }
        },
        saveFonasaData() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    this.displayLoader(true);
                    yield PatientService.update(this.patient_data.id, Object.assign(Object.assign(Object.assign({}, this.patient_data), this.fieldsSelected), { birth_date: moment(this.patient_data.latest_fonasa_validation.birth_date).format("DD-MM-YYYY"), is_prais: this.patient_data.latest_fonasa_validation.is_prais, fonasa_phone: this.patient_data.latest_fonasa_validation.phone }));
                    const RESPONSE_VALIDATION = yield FonasaValidationService.update(this.patient_data.latest_fonasa_validation.id, Object.assign(Object.assign({}, this.patient_data.latest_fonasa_validation), { state: "done" }));
                    yield FonasaValidationHistoryService.create({
                        patient_id: this.patient_data.id,
                        old_patient_data: this.patient_data,
                        new_patient_data: Object.assign(Object.assign({}, this.patient_data), this.fieldsSelected),
                        fonasa_validation_id: RESPONSE_VALIDATION.id,
                        user_id: this.getCurrentUserLoggedIn().id,
                    });
                    this.$parent.close();
                }
                catch (e) {
                    console.log("ERROR AL AGREGAR LOS DATOS DE FONASA", e);
                }
                finally {
                    this.displayLoader(false);
                }
            });
        },
        isDifferent(val1, val2) {
            const norm1 = this.normalizeValue(val1);
            const norm2 = this.normalizeValue(val2);
            return norm1 !== norm2;
        },
        normalizeValue(value) {
            if (value == null)
                return ""; // si es null o undefined
            return value
                .toString()
                .normalize("NFD") // separa tildes
                .replace(/[\u0300-\u036f]/g, "") // elimina tildes
                .toLowerCase()
                .trim();
        },
        getCellStyle(patientValue, fonasaValue, type) {
            if (this.normalizeValue(patientValue) != this.normalizeValue(fonasaValue)) {
                return {
                    backgroundColor: type === "patient" ? "#f8d7da" : "#d4edda",
                };
            }
            return {};
        },
        compareAllFields() {
            const fields = [
                "name",
                "apepat",
                "apemat",
                "gender_id",
                "int_prev_id",
                "conv_prev_id",
                "deceased_date",
            ];
            fields.forEach((field) => {
                const patientVal = this.getNestedValue(this.patient_data, field);
                const fonasaVal = this.getNestedValue(this.fonasa_data, field);
                if (patientVal !== fonasaVal) {
                    this.differences[field] = fonasaVal;
                }
            });
        },
        getNestedValue(obj, path) {
            return path.split(".").reduce((o, p) => (o ? o[p] : undefined), obj);
        },
    },
});
